export default function (el) {
	window.sl_brinde = {
		"id":null,
		"nome":$('input[name="product_name"]').val(),
		"acabs":null,
		"quantidade":0
	};

	$('.item_brinde').on('click', function() {
		const item = $(this).data('item-brinde');
		console.info("item: "+item);
		window.sl_brinde.id = item;
		window.sl_brinde.nome = $(this).data('name');
		$('[data-item-brinde]', el).removeClass('active');
		$(this).addClass('active');
		$('#brinde-image').attr('src', $(this).data('imagem'));
	});

	jQuery('#chat_enviar_brinde').on("click",function(){
		if(!formValid()){
			console.error("form inválido");
			return false;
		}
		let p = new URLSearchParams(window.location.search);
		console.log("click 2");
		let inputs = {
			'nome': "",
			'wa_cliente': jQuery("[name='whatsapp']").val().replace(/\D/g,''),
			'pessoa': 'pj',
			'assunto': "Olá, queria pedir um orçamento do brinde "+window.sl_brinde.nome,
			'utm_source': p.get('utm_source'),
			'utm_medium': p.get('utm_medium'),
			'utm_campaign': p.get('utm_campaign'),
			'utm_url': window.location.href,
			'utm_id': p.get('utm_id'),
		};
		
		console.log("click 3");
		
		let message = encodeURI(`Olá ${inputs.nome}, queria falar sobre...${inputs.assunto}`);
		inputs = new URLSearchParams(inputs).toString();
		fetch("https://api2.sobreloja.com.br/ajax/whatsapp-utm?codigoEmpresa=5&"+inputs).then((response) => {
			console.log(response);
			window.open('https://api.whatsapp.com/send/?phone=5511999315131&text='+message+'&type=phone_number&app_absent=0', "_blank") || window.location.replace('https://api.whatsapp.com/send/?phone=5511999315131&text=Preciso+de+um%20or%C3%A7amento&type=phone_number&app_absent=0');
			return;
		});

		gtag('event', 'form_submit', {
			event_category: 'Forms',
			event_action: 'Submit',
			event_label: inputs.pessoa == "pf" ? 'ESAG-WA-FORM' : "ESAG-WA-FORM-PJ",
			event_value: '2' // Name of your form.
		});

		console.log("acionou evento GTM");

	});

	let formValid = () => {
		if(jQuery("[name='whatsapp']").val().replace(/\D/g,'').length !== 11){
			jQuery("[name='whatsapp']").addClass("bg-danger");
			return false;
		}
		return true;
	};
}